import React from "react";
import ProductModalWrapper from "components/MainApp/organisms/Product/Modals/ProductModalWrapper";

import styles from "./ErrorModal.module.scss";
import i18n from "i18n";
export class ErrorModal extends React.Component {
  render() {
    const {
      open,
      message,

      handleClose,
      handleGoBack,
      handleAddLocalization,
      handleButtonClick, //Buscar nuevamente
    } = this.props;

    const content = (
      <div className={styles["wrong-content-modal-wrapper"]}>
        <div className={styles["wrong-content-modal-title"]}>{i18n.t("non.existent.code")}</div>
        <div className={styles["wrong-content-modal-text"]}>{message}</div>
      </div>
    );

    const footer = (
      <div className={styles["product-modal-wrapper-footer"]}>
        {i18n.t("product.not.exist.information")}{" "}
        <span
          className={styles["product-modal-wrapper-span"]}
          onClick={handleAddLocalization}
          data-automation-id="download-template"
        >
          {i18n.t("product.not.exist.information.sub")}
        </span>
      </div>
    );
    return (
      <div className={styles["wrong-content-modal-container"]}>
        <ProductModalWrapper
          open={open}
          innerContent={content}
          buttonLegend={i18n.t("search.again")}
          handleGoBack={handleGoBack}
          handleClose={handleClose}
          handleButtonClick={handleButtonClick}
          footer={footer}
        ></ProductModalWrapper>
      </div>
    );
  }
}

ErrorModal.propTypes = {};

export default ErrorModal;
